import { RouteObject } from "react-router-dom";
import { GATEWAY_PATH } from "./pages";
import Gateway from "./pages/gateway";

export const gatewayRoutes: RouteObject[] = [
  {
    path: GATEWAY_PATH,
    element: <Gateway />,
  },
];
